<template>
  <ReachSelect
      ref="input"
      :formField="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :label="fieldConfig.labelOnly ? '\u00A0' : fieldConfig.fieldLabel"
      :hint="fieldConfig.labelOnly ? '' :fieldConfig.shortHelpText"
      :help-title="fieldConfig.labelOnly ? '' : fieldConfig.helpWindowTitle"
      :help-message="fieldConfig.labelOnly ? '' :fieldConfig.htmlHelpText"
      :initialFocus="fieldConfig.autofocus"
      :options="options"
      :grid-editor="gridEditor"
      :open-from-grid="openFromGrid"
      @change-parent="changeParent"
  >
    <!--    TODO moze kiedys z tym wrocimy, na razie usuwamy - wprowadza zbyt wiele bledow w systemie, dzialanie tych przyciskow jest niepoprawnie obsluzone-->
    <!--    <template slot="label-links">-->
    <!--      <span v-if="(addEnabled && !readOnly ) || editEnabled" class="pl-0">-->
    <!--        <b-link v-if="(addEnabled && !readOnly )" @click="addNew()" class="pr-1"-->
    <!--                :style="(editEnabled ? 'padding-left: 5px;' : 'padding-left: 4px;') + '; height: 16px;'">-->
    <!--          <font-awesome-icon icon="sparkles" transform="shrink-4"></font-awesome-icon>-->
    <!--        </b-link>-->

    <!--        <b-link v-if="editEnabled" @click="edit()" class="px-0 pr-2 pl-1" style="position: absolute; height: 16px;">-->
    <!--            <font-awesome-icon icon="pencil-alt" transform="shrink-4"></font-awesome-icon>-->
    <!--        </b-link>-->
    <!--      </span>-->
    <!--    </template>-->
  </ReachSelect>
</template>

<script>

import ReachIntInput from "@/components/inputs/ReachIntInput";
import RtModule from "@/utils/RtModule";
import ReachSelect from "@/components/inputs/ReachSelect";
import FormValidatedField from "@/components/forms/FormValidatedField";
import SelectFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig";
import FormsActions from "@/components/forms/FormsActions";
import {classMap} from "@/server/RpcClass";
import CacheManager from "@/components/cacheManager/CacheManager";

const OPTIONS_STATIC = "static";
const OPTIONS_FK_PRELOAD = "fk_preload";
const OPTIONS_FK_DYNAMIC = "fk_dynamic";

export default {
  name: "StaticSelectRenderer",
  components: {ReachSelect, ReachIntInput},
  beforeMount() {

  },

  async mounted() {
    //formConfig.writePermitted
    let field = this.fieldConfig;
    if (field.isForeignKey) {
      let foreignForm = FormsLoader.detectFormConfig(this.fieldConfig.foreignClass, true);
      if (foreignForm) {
        this.addEnabled = foreignForm.writePermitted && foreignForm.addFromForeignSelect;
        this.editEnabled = foreignForm.writePermitted && this.validatedField?.value && foreignForm.editFromForeignSelect;

        this.foreignForm = foreignForm;
        if (!classMap[foreignForm.formClassLong]) {
          return;
        }
        this.$onUpdate(classMap[foreignForm.formClassLong], async (changeEvent) => {
          let opts = this.options;
          let item = this.validatedField.value;
          for (let opt of opts) {
            if (opt.value === changeEvent.id) {
              this.validatedField.getForeignLabel(true).then(label => opt.text = label);
            }
          }
        });
      }
    }
    this.validatedField.onParentFkChange = async (newKey) => {
      let inst = await this.validatedField.getForeignInstance();
      if (inst && inst[this.validatedField.formFieldConfig.filteringFieldByParent] === newKey) {
        return;
      }

      await this.refresh(true);

    }

    if (this.fieldConfig.optionsType === OPTIONS_FK_DYNAMIC) {
      this.initilializedVal = null;
      this.currentOpt = {}
      this.currentOpt.value = this.validatedField.value;
      this.currentOpt.text = "...";

      this.options = [this.currentOpt];

      this.valueSetFromList = false;
      this.valueSetFromCurrent = true;

      this.$refs.input.format = (val) => {
        let res = val != null ? "..." : "";
        for (let opt of this.options) {
          if (opt.value === val) {
            return res = opt.text;
          }
        }
        return res;
      }

      this.validatedField.validatedForm.onLoaded(item => {
        this.initilializedVal = item;
        this.refresh().then();
      });
    } else if (this.fieldConfig.optionsType === OPTIONS_STATIC) {
      this.options = this.fieldConfig.optionsList;
      this.$refs.input.format = (val) =>
          RtModule().get(this.fieldConfig.toStringFunction)
              .call(this.validatedField, val, this.fieldConfig, this.validatedField.getFormConfig());
    } else if (this.fieldConfig.optionsType === OPTIONS_FK_PRELOAD) {
      // TODO refreshowanie dynamicznych atrybutów w momencie edycji się przeładowywuje
      // this.$refs.input.format = this.formatDynamicDictionary;
      this.currentOpt = {};

      this.valueSetFromList = false;
      this.valueSetFromCurrent = false;

      this.$refs.input.format = (val) => {
        if (this.idToLabel.has(val)) {
          return this.idToLabel.get(val);
        }
        return new Promise(resolve => {
          this.validatedField.getForeignLabel(true).then((label) => {
            if (this.validatedField.value === val) {
              this.idToLabel.set(val, label);
              resolve(label);
            }
          });
        });

      }

      this.$onChange(this.fieldConfig.foreignClass, async (changeEvent) => {
        await this.refresh();
      });
    }
    if(!field.computed && this.validatedField.validatedForm.originalSource){
      let listEntities = await this.validatedField.getForeignOptions();
      listEntities.forEach(el => {
        if (this.mode === "NEW" && !this.validatedField.value) {
          if (el.defaultValue) {
            this.validatedField.value = el.id;
          }
        }
      });
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: SelectFormFieldConfig, required: true},
    parentForm: {default: null},
    mode: {default: null},
    openFromGrid: {default: false},
    gridEditor: {default: null},
  },
  watch: {
    "validatedField": function (val) {
      this.refresh();
    },
    "validatedField.value": function (val) {
      this.refreshVal();
    }
  },
  methods: {
    changeParent() {
      this.$emit("change-parent");
    },

    setRegion(region){
      this.$refs.input.setRegion?.(region);
      this.regionCode = region;
      if (this.fieldConfig.optionsType === OPTIONS_FK_PRELOAD) {
        this.loadDict(null, false);
      }

    },

    // TODO
    async formatDynamicDictionary(val) {
      let label = await this.formField.getForeignLabel(true);
      this.idToLabel.set(val, label);
      return label;
    },
    sortTable(table) {
      const reToConvertStringToInt = /\b\d+\b/;
      const reToRemoveSpace = /(\s+)?(\(?\w+(\.\w+)*\)?)/;
      table.join()
      table.sort(function (a, b) {
        let textA = a.text;
        let textB = b.text;

        if (textA.match(reToConvertStringToInt)) {
          textA = Number(textA);
        } else if (typeof textA === 'string') {
          textA = textA.toLowerCase();
          if (textA !== null && textA !== "") {
            textA = textA?.match(reToRemoveSpace)?.[2]
          }
        }

        if (textB.match(reToConvertStringToInt)) {
          textB = Number(textB);
        } else if (typeof textB === 'string') {
          textB = textB.toLowerCase();
          if (textB !== null && textB !== "" && textB.length > 1)
            textB = textB?.match(reToRemoveSpace)[2]
        }

        if (textA < textB) {
          return -1;
        }

        if (textA > textB) {
          return 1;
        }

        return 0;
      });
    },
    async addNew() {
      if (this.foreignForm) {
        await FormsActions.create(this.foreignForm);
      }
    },

    async edit() {
      if (this.foreignForm && this.validatedField.value) {
        let entity = await Rpc.Forms.getEntity(this.foreignForm.formClassLong, this.validatedField.value)
        await FormsActions.edit(entity);
      }
    },

    async refreshVal() {
      await this.refresh(null, true);
    },

    async refresh(fromParent, onlyValue) {
      if (this.fieldConfig.optionsType === OPTIONS_STATIC) {
        this.options = this.fieldConfig.optionsList;
        return;
      }

      if (this.fieldConfig.optionsType === OPTIONS_FK_PRELOAD) {
        this.refreshFkPreload(fromParent, onlyValue);
        return;
      }

      if (this.fieldConfig.optionsType === OPTIONS_FK_DYNAMIC) {
        await this.refreshFkDynamic(fromParent, onlyValue);
        return;
      }
    },

    async refreshFkDynamic(fromParent, onlyValue) {
      let inst = this.validatedField.validatedForm.originalSource ?? this.initilializedVal;

      if (inst || this.fieldConfig.providerIsStatic) {
        let opts = await Rpc.Forms.getSelectOptions(this.parentForm.formConfig.formClassLong,
            this.validatedField.formFieldConfig.fieldName, inst);
        let optsArr = [];
        for (let k in opts) {
          optsArr.push({
            value: k,
            text: opts[k]
          })
        }
        this.options = optsArr;
      }
    },

    refreshFkPreload(fromParent, onlyValue) {
      this.listLoaded = false;
      this.valueSetFromCurrent = false;
      this.valueSetFromList = false;
      this.optionsList = [];
      this.idToLabel = new Map();
      this.nullAdded = false;

      let fieldName = this.validatedField.formFieldConfig.fieldName;
      if (this.validatedField.value !== null) {
        if (!fromParent) {
          this.validatedField.getForeignLabel().then(label => {
            if (!this.valueSetFromList && !this.valueSetFromCurrent && !this.idToLabel.has(this.validatedField.value)) {
              this.currentOpt.value = this.validatedField.value;
              this.currentOpt.text = label;
              this.idToLabel.set(this.currentOpt.value, this.currentOpt.text);
              this.$refs.input?.formatVal?.();
              if (this.currentOpt.value != null) {
                this.optionsList.unshift(this.currentOpt);
              } else {
                if (!this.nullAdded) {
                  this.optionsList.unshift(this.nullRow);
                  this.nullAdded = true;
                }
              }

              if (!this.nullAdded) {
                this.optionsList.unshift(this.nullRow);
                this.nullAdded = true;
              }

              this.options = this.optionsList;
              this.valueSetFromCurrent = true;

              if (this.listLoaded) {
                this.validatedField.detailsLoadInProgress = false;
              }
            }
          });
        }
      }
      // if (!this.readOnly) {
      this.loadDict(fromParent, onlyValue);
      // }

      this.editEnabled = this.foreignForm?.writePermitted && this.validatedField.value && this.foreignForm?.editFromForeignSelect;
    },

    loadDict(fromParent, onlyValue) {
      if (this.fieldConfig.optionsType === OPTIONS_STATIC) {
        this.options = this.fieldConfig.optionsList;

        return;
      }
      if (this.fieldConfig.optionsType === OPTIONS_FK_DYNAMIC) {
        return;
      }

      if (this.loadInProgress) {
        return;
      }

      this.validatedField.detailsLoadInProgress = true;
      this.loadInProgress = true;
      this.loadingParentId = this.validatedField.getParentFkKey();
      let fieldName = this.validatedField.formFieldConfig.fieldName;

      let refresh = async (list) => {
        this.lastList = list;
        this.loadInProgress = false;
        if (this.loadingParentId != this.validatedField.getParentFkKey()) {
          this.loadDict();
          return;
        }

        let localList = [];

        list.forEach(el => {
          this.idToLabel.set(el.id, el.getInstanceLabel());

          if (el.id === this.validatedField.value) {
            this.currentOpt.value = this.validatedField.value;
            this.currentOpt.text = el.getInstanceLabel();
            this.valueSetFromList = true;
            this.$refs.input?.formatVal?.();
          } else {
            localList.push({value: el.id, text: el.getInstanceLabel()});
          }
        });


        let resetValue = false;
        _.sortBy(localList, ['text']);
        if (!this.valueSetFromCurrent && this.valueSetFromList) {
          if (this.currentOpt.value != null && !this.optionsList.find(element => element.value === this.currentOpt.value)) {
            this.optionsList.unshift(this.currentOpt);
          }
        } else if (!this.valueSetFromList && fromParent) {
          resetValue = true;
        }

        if (!this.nullAdded) {
          this.optionsList.unshift(this.nullRow);
          this.nullAdded = true;
        }

        localList.forEach(el => {
          if (!this.optionsList.find(value => value.value === el.value)) {
            this.optionsList.push(el);
          }
        });

        this.listLoaded = true;
        if (resetValue) {
          this.validatedField.value = null;
        }

        if (this.valueSetFromList || this.valueSetFromCurrent || this.validatedField.value == null) {
          this.validatedField.detailsLoadInProgress = false;
          this.options = [...this.optionsList];
          this.sortTable(this.options);
        } else if (this.validatedField.value && !this.valueSetFromList && !this.valueSetFromCurrent) {
          this.$nextTick(async () => {
            let entityLabel = await Rpc.Forms.getEntityLabel(this.fieldConfig.foreignClass, this.validatedField.value);
            this.validatedField.detailsLoadInProgress = false;
            this.options = [...this.optionsList];
            this.options.splice(1, 0, {value: this.validatedField.value, text: entityLabel});
            this.sortTable(this.options);
          });
        }
      };

      if (onlyValue && this.lastList) {
        refresh(this.lastList);
      } else {
        if (!this.fieldConfig.readOnly) {
          if (this.validatedField.validatedForm.originalSource || !this.validatedField.formFieldConfig.hasContextFilter) {
            this.validatedField.getForeignOptions(this.regionCode).then(refresh);
          } else {
            this.validatedField.validatedForm.onLoaded(() =>
                this.validatedField.getForeignOptions(this.regionCode).then(refresh));
          }
        } else {
          this.loadInProgress = false;
          this.validatedField.detailsLoadInProgress = false;
        }
      }
    },

    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
      if (this.readOnly !== this.lastReadOnly) {
        if (!readOnly) {
          this.loadDict();
        }
        this.lastReadOnly = this.readOnly;
      }
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

  },

  data: () => ({
    regionCode: 'def',
    options: [],
    idToLabel: new Map(),
    readOnly: true,
    editorMode: false,

    loadInProgress: false,
    loadingParentId: null,
    currentOpt: {},
    valueSetFromList: false,
    valueSetFromCurrent: false,
    nullAdded: false,
    listLoaded: false,
    optionsList: [],
    nullRow: {value: null, text: ''},
    lastList: null,
    addEnabled: false,
    editEnabled: false,
    detailFormConfig: null,
    lastReadOnly: null,
    /**
     * @type {FormConfig}
     */
    foreignForm: null

  })
}
</script>

<style scoped>

</style>